import React from 'react';
import { Box, Grid, Card, CardContent, Typography } from '@mui/material';
import { FaSyncAlt, FaTimesCircle, FaExclamationCircle, FaHandHoldingHeart } from 'react-icons/fa';

const statItems = (stats) => [
    {
        icon: FaSyncAlt,
        title: 'Active Subscriptions',
        value: stats.total_active,
        color: '#107C10',
        bg: '#EBF5EB',
    },
    {
        icon: FaTimesCircle,
        title: 'Cancelled',
        value: stats.total_cancelled,
        color: '#605D5C',
        bg: '#F3F2F1',
    },
    {
        icon: FaExclamationCircle,
        title: 'Failed',
        value: stats.total_failed,
        color: '#D83B01',
        bg: '#FEF0EB',
    },
    {
        icon: FaHandHoldingHeart,
        title: 'Total Donations Made',
        value: stats.total_donations,
        color: '#2D4A3D',
        bg: '#EFF6FC',
    },
];

const RecurringStats = ({ stats }) => {
    const items = statItems(stats);

    return (
        <Box sx={{ mb: 3 }}>
            <Grid container spacing={2}>
                {items.map((item, index) => {
                    const Icon = item.icon;
                    return (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card
                                sx={{
                                    borderRadius: 2,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                                    border: '1px solid #E1E1E1',
                                    height: '100%',
                                }}
                            >
                                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2.5 }}>
                                    <Box
                                        sx={{
                                            width: 48,
                                            height: 48,
                                            borderRadius: 2,
                                            backgroundColor: item.bg,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                        }}
                                    >
                                        <Icon style={{ color: item.color, fontSize: '1.3rem' }} />
                                    </Box>
                                    <Box>
                                        <Typography
                                            variant="h5"
                                            sx={{ fontWeight: 'bold', color: item.color, lineHeight: 1.2 }}
                                        >
                                            {item.value?.toLocaleString() ?? 0}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{ color: '#605D5C', fontSize: '0.8rem', mt: 0.25 }}
                                        >
                                            {item.title}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default RecurringStats;
